import React from 'react'
import { apiFetch } from '../../../fetchApi'

export const deleteEducation = ({ BeURL, id, handleTopClear, candidateId, showAlert }) => {
    apiFetch(`${BeURL}/candidate-education-delete/${id}/${candidateId}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                handleTopClear()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate education", err)
        })
}
